"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TradeWindow;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TradeWindowModule = _interopRequireDefault(require("./TradeWindow.module.scss"));

var _ItemPool = _interopRequireDefault(require("../../../entities/ItemPool/ItemPool"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
TODO: trading money
- when a character wants to trade money, he must click on the money inside his inventory
    - then an input.window will appear, for the amount
    - when he clicks ok, the amount will be set inside the trade window. inside the inventory, the number turns red
*/
function TradeWindow(_ref) {
  var _ref$nameMe = _ref.nameMe,
      nameMe = _ref$nameMe === void 0 ? "Me" : _ref$nameMe,
      _ref$nameThem = _ref.nameThem,
      nameThem = _ref$nameThem === void 0 ? "Them" : _ref$nameThem,
      itemPoolMe = _ref.itemPoolMe,
      itemPoolThem = _ref.itemPoolThem,
      _ref$PPMe = _ref.PPMe,
      PPMe = _ref$PPMe === void 0 ? 0 : _ref$PPMe,
      _ref$GPMe = _ref.GPMe,
      GPMe = _ref$GPMe === void 0 ? 0 : _ref$GPMe,
      _ref$CPMe = _ref.CPMe,
      CPMe = _ref$CPMe === void 0 ? 0 : _ref$CPMe,
      _ref$PPThem = _ref.PPThem,
      PPThem = _ref$PPThem === void 0 ? 0 : _ref$PPThem,
      _ref$GPThem = _ref.GPThem,
      GPThem = _ref$GPThem === void 0 ? 0 : _ref$GPThem,
      _ref$CPThem = _ref.CPThem,
      CPThem = _ref$CPThem === void 0 ? 0 : _ref$CPThem,
      onSubmitMe = _ref.onSubmitMe,
      onSubmitThem = _ref.onSubmitThem,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  if (itemPoolMe && (itemPoolMe.sizeX !== 8 || itemPoolMe.sizeY !== 4)) {
    throw new Error("itemPoolMe with invalid size '".concat(itemPoolMe.sizeX, "x").concat(itemPoolMe.sizeY, "' was passed to TradeWindow."));
  }

  if (itemPoolThem && (itemPoolThem.sizeX !== 8 || itemPoolThem.sizeY !== 4)) {
    throw new Error("itemPoolThem with invalid size '".concat(itemPoolThem.sizeX, "x").concat(itemPoolThem.sizeY, "' was passed to TradeWindow."));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TradeWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _TradeWindowModule.default.dragHandler,
    classNameCloseBtn: _TradeWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _TradeWindowModule.default.me
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TradeWindowModule.default.name
  }, nameMe), /*#__PURE__*/_react.default.createElement("div", {
    className: _TradeWindowModule.default.itemPool
  }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
    sizeX: 8,
    sizeY: 4,
    itemPool: itemPoolMe
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TradeWindowModule.default.money, " ").concat(_TradeWindowModule.default.PP)
  }, PPMe), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TradeWindowModule.default.money, " ").concat(_TradeWindowModule.default.GP)
  }, GPMe), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TradeWindowModule.default.money, " ").concat(_TradeWindowModule.default.CP)
  }, CPMe), /*#__PURE__*/_react.default.createElement("div", {
    className: _TradeWindowModule.default.submit
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.OPPOSITE_OK,
    onClick: function onClick() {
      if (onSubmitMe) onSubmitMe();
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _TradeWindowModule.default.them
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TradeWindowModule.default.name
  }, nameThem), /*#__PURE__*/_react.default.createElement("div", {
    className: _TradeWindowModule.default.itemPool
  }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
    sizeX: 8,
    sizeY: 4,
    itemPool: itemPoolThem
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TradeWindowModule.default.money, " ").concat(_TradeWindowModule.default.PP)
  }, PPThem), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TradeWindowModule.default.money, " ").concat(_TradeWindowModule.default.GP)
  }, GPThem), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TradeWindowModule.default.money, " ").concat(_TradeWindowModule.default.CP)
  }, CPThem), /*#__PURE__*/_react.default.createElement("div", {
    className: _TradeWindowModule.default.submit
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.MY_OK,
    onClick: function onClick() {
      if (onSubmitThem) onSubmitThem();
    }
  }))));
}